var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttempted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00317383 0.5H27V27.5H0.00317383V0.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 14C27 17.4687 25.6919 20.6321 23.5418 23.023C21.0705 25.7715 17.4872 27.5 13.5 27.5C9.51281 27.5 5.92951 25.7715 3.45821 23.023C1.30813 20.6321 0 17.4687 0 14C0 10.5313 1.30813 7.36791 3.45821 4.97704C4.62032 3.68437 6.0287 2.61702 7.60957 1.84947C9.38941 0.984893 11.3879 0.5 13.5 0.5C15.6121 0.5 17.6106 0.984893 19.3904 1.84947C20.9713 2.61702 22.3797 3.68437 23.5418 4.97704C25.6919 7.36791 27 10.5313 27 14Z",
    fill: "#FF724F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5418 1.84949V23.023C21.0705 25.7715 17.4872 27.5 13.5 27.5C9.51284 27.5 5.92954 25.7715 3.45825 23.023V1.84949H23.5418Z",
    fill: "#ECF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5752 22.5171L20.0957 20.7572L19.6163 22.5171H20.5752ZM18.1913 23.8962C18.1913 23.8766 18.1979 23.8502 18.2044 23.824L19.426 19.8181C19.4982 19.5882 19.7936 19.4766 20.0957 19.4766C20.3979 19.4766 20.6933 19.5882 20.7656 19.8181L21.9937 23.824C22.0003 23.8502 22.0068 23.8765 22.0068 23.8962C22.0068 24.1392 21.6324 24.3165 21.3501 24.3165C21.1859 24.3165 21.0546 24.264 21.0151 24.1261L20.7919 23.3052H19.4061L19.1829 24.1261C19.1435 24.264 19.0121 24.3165 18.848 24.3165C18.5656 24.3165 18.1913 24.1392 18.1913 23.8962Z",
    fill: "#DE4A57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3801 17.4768C21.3612 17.5176 21.3325 17.562 21.2932 17.5935L16.6356 21.3907C16.541 21.4707 16.3804 21.479 16.2512 21.4194C16.02 21.3126 15.9583 21.0532 16.0368 20.8831C16.0556 20.8424 16.0912 20.8011 16.1305 20.7697L20.7813 16.9693C20.889 16.8788 21.0229 16.8746 21.1454 16.9311C21.3358 17.0191 21.4806 17.2592 21.3801 17.4768Z",
    fill: "#DE4A57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9217 6.50542H9.0783C8.71317 6.50542 8.41711 6.20942 8.41711 5.84429C8.41711 5.4791 8.71317 5.18311 9.0783 5.18311H17.9217C18.2869 5.18311 18.5829 5.4791 18.5829 5.84429C18.5829 6.20942 18.2869 6.50542 17.9217 6.50542Z",
    fill: "#86A1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1055 10.3189H5.89452C5.52934 10.3189 5.23334 10.0229 5.23334 9.65777C5.23334 9.29258 5.52934 8.99658 5.89452 8.99658H21.1055C21.4707 8.99658 21.7667 9.29258 21.7667 9.65777C21.7667 10.0228 21.4707 10.3189 21.1055 10.3189Z",
    fill: "#86A1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1055 12.8363H5.89452C5.52934 12.8363 5.23334 12.5403 5.23334 12.1751C5.23334 11.81 5.52934 11.5139 5.89452 11.5139H21.1055C21.4707 11.5139 21.7667 11.81 21.7667 12.1751C21.7667 12.5403 21.4707 12.8363 21.1055 12.8363Z",
    fill: "#86A1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1055 15.3537H5.89452C5.52934 15.3537 5.23334 15.0577 5.23334 14.6925C5.23334 14.3274 5.52934 14.0314 5.89452 14.0314H21.1055C21.4707 14.0314 21.7667 14.3274 21.7667 14.6925C21.7667 15.0577 21.4707 15.3537 21.1055 15.3537Z",
    fill: "#86A1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6848 17.871H5.89452C5.52934 17.871 5.23334 17.575 5.23334 17.2098C5.23334 16.8447 5.52934 16.5487 5.89452 16.5487H14.6848C15.0499 16.5487 15.3459 16.8447 15.3459 17.2098C15.3459 17.575 15.0499 17.871 14.6848 17.871Z",
    fill: "#86A1AE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempted);
export default __webpack_public_path__ + "static/media/attempted.f3dd54dc56ce9869416f1c60f6e77ca8.svg";
export { ForwardRef as ReactComponent };